import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-propiedades-servicio',
  templateUrl: './propiedades-servicio.component.html',
  styleUrls: ['./propiedades-servicio.component.scss']
})
export class PropiedadesServicioComponent implements OnInit {

  @Input() presencia: string[] = [];
  @Input() duracion: string = '';
  @Input() duracionGrupal: string = '';
  @Input() duracionIndividual: string = '';
  
  constructor() { }

  ngOnInit() {
  }

}
